import { inject, injectable } from "inversify";
import IAlertService from "../alert/IAlertService";
import ISessionService from "../auth/ISessionService";
import { getCookie } from "../../utilities/cookieHelper";
import { DiTokens } from "../diTokens";
import IErrorService from "./IErrorService";

@injectable()
/** Сервис обработки ошибок */
export default class ErrorService implements IErrorService {
  constructor(
    @inject(DiTokens.AlertService) private alertService: IAlertService,
    @inject(DiTokens.SessionService) private sessionService: ISessionService
  ) {}

  /**Текст ошибки */
  public error: string = "";

  /**
   * Метод обработки ошибок
   * @param error Ошибка
   * @param isCritical Признак критической ошибки
   * @param checkAuth Признак проверки наличия авторизации у клиента
   * @param msg Отображаемое сообщение
   */
  public async errorHandler(
    error: Error,
    isCritical: boolean = false,
    checkAuth: boolean = false,
    msg: string = ""
  ): Promise<void> {
    const sessionTimeout = parseInt(getCookie("fspbSessionTimeout"));

    if (checkAuth && error.name.indexOf("401") >= 0) {
      if (isNaN(sessionTimeout))
        return;
      if (error.message !== 'Session timeout.') {
        this.alertService.error(error.message);
      }
      this.sessionService.timeoutSession(true);
      return;
    }

    if (isCritical) {
      this.error = error.message;
      return;
    }

    const errorText = msg || error.message;

    this.alertService.error(errorText);
  }
}
